import { render, staticRenderFns } from "./PhoneNumberInput.vue?vue&type=template&id=d52e8e9c&scoped=true"
import script from "./PhoneNumberInput.vue?vue&type=script&lang=ts"
export * from "./PhoneNumberInput.vue?vue&type=script&lang=ts"
import style0 from "./PhoneNumberInput.vue?vue&type=style&index=0&id=d52e8e9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d52e8e9c",
  null
  
)

export default component.exports